export const apiConstants = {
  updateUserUrl: "/api/update-user-privacy"
};
